export const CREATORS = [
  'aisan000531',
  'watashiwatotem',
  'paultask_game',
] as const
export type CREATOR = (typeof CREATORS)[number]

export const mapDBDCreatorInfo: Record<
  CREATOR,
  {
    profileCardImageURL: string
    creatorImageURL: string
  }
> = {
  aisan000531: {
    creatorImageURL: '/static/images/creators/aisan000531.png',
    profileCardImageURL: '/static/images/profiles/dbd1/0.jpeg',
  },
  watashiwatotem: {
    profileCardImageURL: '/static/images/profiles/dbd2/0.jpeg',
    creatorImageURL: '/static/images/creators/watashiwatotem.png',
  },
  paultask_game: {
    profileCardImageURL: '/static/images/profiles/dbd3/0.jpeg',
    creatorImageURL: '/static/images/creators/paultask_game.png',
  },
}
